import React, {Component, Fragment} from 'react';
import isEmpty from 'is-empty';

import {closeModal} from '../../shared/components/layouts/OldModal';

import Alert from '../../shared/components/notices/Alert';
import ContactManagerExistingContactsList from './ExistingContactsList';
import ContactManagerFormContainer from './FormContainer';
import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {TrackEventName} from '../../shared/constants/SegmentEvents';

class ContactManagerContainer extends Component {
  state = {
    tabActive: this.tabActive,
    selectedContact: this.props.selectedContact || {},
    showConfirmation: false,
  };

  componentDidMount() {
    if (!isEmpty(this.state.selectedContact)) {
      this.setState({tabActive: 2});
    }
  }

  get tabActive() {
    return this.props.contacts.length > 0 ? 1 : 2;
  }

  onTabClickTrackEvent(value) {
    switch (value) {
      case 1:
        segmentEventTracker.trackEvent(TrackEventName.MODAL_CANCEL_CLICKED);
        break;
      case 2:
        segmentEventTracker.trackEvent(
          TrackEventName.ADD_CONTACT_MODAL_ADD_NEW_CONTACT_CLICKED,
        );
        break;
      default:
        return null;
    }
  }

  onTabClick = value => {
    return () => {
      this.onTabClickTrackEvent(value);
      let states = {tabActive: value};
      if (this.state.tabActive !== value) {
        states = Object.assign({}, states, {selectedContact: {}});
      }
      this.setState(states);
    };
  };

  onEditContact = contact => {
    return e => {
      e && e.stopPropagation();
      this.setState({tabActive: 2, selectedContact: contact});
    };
  };

  onShowDeleteConfirmation = () => {
    this.setState({showConfirmation: true});
  };

  onCancelConfirmation = () => {
    this.setState({showConfirmation: false});
  };

  onDeleteContact = () => {
    const onSuccess = () => closeModal();
    const onError = () => {
      this.setState({showConfirmation: false});
      Alert(
        'Delete Unsuccessful! Contact is already associated to another buyer.',
        'error',
      );
    };
    this.props.onDeleteContact(
      this.state.selectedContact.id,
      onSuccess,
      onError,
    );
  };

  renderContent() {
    if (this.state.tabActive === 1) {
      return (
        <ContactManagerExistingContactsList
          onTabClick={this.onTabClick}
          contacts={this.props.contacts}
          tradeContacts={this.props.tradeContacts}
          onAddTradeContact={this.props.onAddTradeContact}
          onEditContact={this.onEditContact}
        />
      );
    } else if (this.state.tabActive === 2) {
      return (
        <ContactManagerFormContainer
          contact={this.state.selectedContact}
          contacts={this.props.contacts}
          tradeContacts={this.props.tradeContacts}
          onAddContact={this.props.onAddContact}
          onUpdateContact={this.props.onUpdateContact}
          onTabClick={this.onTabClick}
          onAddTradeContact={this.props.onAddTradeContact}
          onDeleteContact={this.onShowDeleteConfirmation}
        />
      );
    } else {
      return <div />;
    }
  }

  renderFormTabLabel() {
    if (isEmpty(this.state.selectedContact)) {
      return 'Create New Contact';
    } else {
      return 'Edit Contact';
    }
  }

  get header() {
    return this.props.docType === 'purchase_orders'
      ? 'Who gave you this purchase order?'
      : 'Who did you issue this invoice to?';
  }

  renderBody() {
    if (this.state.showConfirmation) {
      return (
        <section className="cardSection _withColumns">
            <div className="text">
                <p className="copy">Are you sure you want to delete this account?</p>
            </div>
            <div className="ds-buttonGroup _spacedButtons">
              <button data-testid='delete-contact-yes' className="ds-btn _marginRight--small" onClick={this.onDeleteContact}>Yes</button>
              <button data-testid='delete-contact-no' className="ds-btn -danger" onClick={this.onCancelConfirmation}>No</button>
            </div>
        </section>
      );
    } else {
      return (
        <Fragment>
          <section className="cardTitle _withButton">
            <p>
              {this.header}
              (Your customer's contact information)
            </p>
          </section>
          {this.renderContent()}
        </Fragment>
      );
    }
  }

  render() {
    return this.renderBody();
  }
}

export default ContactManagerContainer;



// WEBPACK FOOTER //
// ./src/features/contacts/components/Container.js